// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1BNNe","notes":"Notes_notes__yYGV2","note":"Notes_note__3wv5r","markdown":"Notes_markdown__3gjpg"};